import Constants from './constants';

export default {
    INVALID_IDENTIFIER : "Invalid ",
    INVALID_TXN_TYPE : "Invalid Tran. Group",
    INVALID_START_DATE : "Invalid start date",
    INVALID_END_DATE : "Invalid end date",
    INVALID_DATE_RANGE : `Invalid date range. Max. of ${Constants.MAX_DATE_RANGE_MONTHS} month(s).` ,
    INVALID_REQUESTED_AMOUNT : "Invalid Requested Amount",
    INVALID_REASON_CODE : "Invalid Reason Code",
    INVALID_DISPENSE_TYPE : "Invalid Dispense Type",
    INVALID_DISPUTE_CATEGORY : "Invalid Dispute Category",

    ERROR_TRANSACTIONS_SEARCH : "Error fetching transactions",
    ERROR_TRANSACTIONS_SEARCH_TITLE : "Could not get Transactions",

    ERROR_TRANSACTION_FETCH : "Error fetching transaction",

    ERROR_TRANSACTION_GROUPS : "Could not fetch transaction groups",

    ERROR_DISPUTES_SEARCH : "Error fetching disputes",
    ERROR_DISPUTES_SEARCH_TITLE : "Could not get disputes",
    ERROR_DISPUTE_TRANSACTION_FETCH : "Error fetching transaction",

   
    ERROR_DISPUTE_FETCH_TITLE : "Could not get dispute",
    ERROR_DISPUTE_REGION : "Could not get dispute regions",
    ERROR_DISPUTE_SETTLEMENTS_TITLE : "Could not get settlements",

    ERROR_REASON_CODES : "Could not get Reason Codes",

    SUCCESS_DISPUTE_CREATION : "Dispute successfuly created",
    ERROR_DISPUTE_CREATION : "Error Creating dispute",
    
    SUCCESS_DISPUTE_ACTION : "Action Successful",
    ERROR_DISPUTE_ACTION : "Could not perform Action",

    ERROR_FILE_TOO_LARGE_TITLE :"Too Large",
    ERROR_FILE_TOO_LARGE : "Selected file too large. Maximum file size is ",

    ERROR_EVIDENCE_ADD : "Could not add evidence ",

    ERROR_MAXIMUM_EVIDENCE_UPLOAD_COUNT : "Maximum number of evidence files exceeded",
    ERROR_EVIDENCE_INVALID_FILE_TYPE_TITLE: "Bad file format",
    ERROR_EVIDENCE_INVALID_FILE_TYPE: "Unsupported file format. Only JPEG and PNG formats are supported ",
    ERROR_EVIDENCE_NO_FILE_SELECTED: "No files selected",
    ERROR_EVIDENCE_REQUIRED : "Evidence required to perform action on Dispute. Please attach evidence.",
    ERROR_COMMENT_REQUIRED : "Comment required to perform action on Dispute. Please add a comment.",



    ACTION_NEVER_ASK : "Never ask for this action again.",
    ACTION_WARNING : "Are you sure you want to perform the action"


    
};


// WEBPACK FOOTER //
// ./src/configurations/messages.js